export default {
  success: 1,
  error: -1,
  system_error: -2,
  sessionTimeout: -15,
  notFound: -400
};
